import type {} from '@angular/localize/init';
import type { TranslationConfig } from '@bcf-v2/routes-statics/common/app/i18n-cache';
import { appRoutesI18nCache } from '../i18n-cache';

export function tableGamesRouteI18n(config?: TranslationConfig): string {
  if (config?.translateForLang && globalThis.$localizeForLang) {
    return globalThis.$localizeForLang`:url-segment@@table-games-url-segment:table-games`;
  }
  return (appRoutesI18nCache['table-games'] ??= $localize`:url-segment@@table-games-url-segment:table-games`);
}
